import React from 'react';

import classes from './HR.module.scss';

function HR({ color = '#e0e1e7', style = {} }) {
  return <hr className={classes.hr} style={{ ...style }} color={color} />
};

export default HR